import { useCallback, useEffect, useState } from 'react'

import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { SarDetails } from '~bank-bsa-reporting/types'

const defaultFilter = (id: number) => ({
  historyPage: 1,
  historySize: 10,
  id
})

export const useGetSARDetails = (id: number) => {
  const [filter, setFilter] = useState(defaultFilter(id))

  useEffect(() => {
    setFilter(defaultFilter(id))
  }, [id])

  const onHistoryFilterChange = useCallback(
    (page: number, size: number) => {
      if (page !== filter.historyPage || size !== filter.historySize) {
        setFilter({ ...filter, historyPage: page, historySize: size })
      }
    },
    [filter]
  )

  const { data, isFetching } = useQuery<SarDetails>({
    queryKey: ['sar-details', filter],
    queryFn: () => Request.post(Request.urls.bank.sarDetails, filter),
    placeholderData: keepPreviousData
  })

  return {
    data,
    isFetching,
    onHistoryFilterChange
  }
}
